<script>
import { groupBy } from "lodash";
export default {
    name: 'DusLibItems',
    props: {
        modalTitle: {
            type: String,
            default: 'Dus Lib Items',
        },
    },
    data() {
        return {
            filterItem: "",
            perPageItem: 10,
            currentPageItem: 1,
            resourceItems: [],
            pageOptions: [10, 25, 50, 100],
            itemLoading: false,
            detail: {
                id: 0,
                monthId: 0,
                quantity: "0",
                totalAmt: 0,
            },
            selectedBudgetAmount: 0,
        };
    },
    computed: {
        filteredResourceItems() {
            let data = this.resourceItems;
            var total = this.currentPageItem * this.perPageItem;
            if (this.filterItem.trim() != "" && this.filterItem) {
                data = data.filter((item) => {
                    return item.itemName
                        .toUpperCase()
                        .includes(this.filterItem.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPageItem, total);
            if (this.currentPageItem > 1 && currentData.length == 0) {
                total = (this.currentPageItem - 1) * this.perPageItem;
                currentData = data.slice(total - this.perPageItem, total);
            }
            var groupedApi = groupBy(currentData, "planningApiId");
            var grouped = [];
            var id = 1;
            for (const key in groupedApi) {
                grouped.push({
                    id: id++,
                    apiName: groupedApi[key][0].apiName,
                    data: groupedApi[key],
                });
            }
            return grouped;
        },
        rowsResourceItem() {
            if (this.filterItem.trim() != "" && this.filterItem) {
                return this.filteredResourceItems.length;
            } else {
                return this.resourceItems.length;
            }
        },
        totalBudget() {
            var totalBalance = this.selectedBudgetAmount;
            return (totalBalance -= parseFloat(this.detail.totalAmt));
        },
    },
    methods: {
        totalResourceItemAmt() {
            var data = this.resourceItems;
            var sum = 0;
            data.forEach((item) => {
                sum += parseFloat(item.totalWithInflation);
            });
            return this.formatCurrency(sum);
        },
        getResourceDetails(id) {
            this.resourceItems = [];
            this.itemLoading = true;
            this.$store
                .dispatch("planningapiresource/GetAllPlanningApiResources", id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((item) => {
                        var totalQty = 0;
                        item.planningApiResourceDetails.forEach((x) => {
                            totalQty += x.quantity;
                        });
                        item.quantity = totalQty;
                        item.total =
                            parseFloat(totalQty) * parseFloat(item.unitCost);
                        item.apiName = item.planningApi.name;
                    });
                    this.resourceItems = res.data;
                    this.itemLoading = false;
                })
                .catch((err) => {
                    this.itemLoading = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
    }
};
</script>
<template>
    <b-modal id="dus-lib-items-modal" :title="modalTitle" size="xxl" title-class="font-18" hide-footer
        no-close-on-backdrop no-close-on-esc>
        <div class="row">
            <b-col sm="6" class="d-flex">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                    <label class="
                            d-inline-flex
                            align-items-center
                        ">
                        <b-form-input autocomplete="off" v-model="filterItem" type="search"
                            placeholder="Search Items..." class="form-control"></b-form-input>
                    </label>
                </div>
                <div id="tickets-table_length" class="dataTables_length">
                    <label class="
                            d-inline-flex
                            align-items-center
                            mb-0
                        ">
                        <b-form-select class="form-select" v-model="perPageItem" size="sm"
                            :options="pageOptions"></b-form-select>
                    </label>
                </div>
            </b-col>
            <b-col sm="6" class="text-right">
                <h4 class="text-muted mb-0">
                    Balance:
                    <b>{{ formatCurrency(totalBudget) }}</b>
                </h4>
                <h4 class="text-warning">
                    Total: <b>{{ totalResourceItemAmt() }}</b>
                </h4>
            </b-col>
        </div>
        <b-row>
            <b-col sm="12" class="mt-2">
                <div class="row">
                    <div class="col-lg-12">
                        <div>
                            <div class="table-responsive">
                                <table class="
                                        table
                                        project-list-table
                                        table-centered
                                        table-borderless
                                        align-middle
                                    ">
                                    <thead>
                                        <tr>
                                            <th scope="col" width="30px">
                                            </th>
                                            <th scope="col">
                                                Item Name
                                            </th>
                                            <th scope="col">
                                                Description
                                            </th>
                                            <th scope="col" width="120px">
                                                Qty
                                            </th>
                                            <th scope="col" width="200px">
                                                Unit Cost
                                            </th>
                                            <th scope="col" width="200px">
                                                Total
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="itemLoading">
                                            <td colspan="7">
                                                <div class="
                                                        d-flex
                                                        justify-content-center
                                                        align-items-center
                                                    ">
                                                    <div class="
                                                            preloader-component
                                                            me-2
                                                        ">
                                                        <div class="
                                                                status
                                                            ">
                                                            <div class="
                                                                    spinner-chase
                                                                    w-20px
                                                                    h-20px
                                                                ">
                                                                <div class="
                                                                        chase-dot
                                                                    "></div>
                                                                <div class="
                                                                        chase-dot
                                                                    "></div>
                                                                <div class="
                                                                        chase-dot
                                                                    "></div>
                                                                <div class="
                                                                        chase-dot
                                                                    "></div>
                                                                <div class="
                                                                        chase-dot
                                                                    "></div>
                                                                <div class="
                                                                        chase-dot
                                                                    "></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <strong>Loading...</strong>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="
                                            filteredResourceItems.length ==
                                            0 &&
                                            !itemLoading
                                        ">
                                            <td colspan="100%" class="
                                                    text-muted
                                                    text-center
                                                ">
                                                <i class="
                                                        dripicons-warning
                                                        me-1
                                                    "></i>No data found
                                            </td>
                                        </tr>
                                        <template v-for="y in filteredResourceItems">
                                            <tr :key="`firstRow-${y.id}`"
                                                style="background-color: transparent; box-shadow: none;">
                                                <td colspan="7" class="p-0"><b>{{ y.apiName }}</b></td>
                                            </tr>
                                            <template v-for="x in y.data">
                                                <tr :key="`secondRow-${y.id}-${x.id}`"
                                                    style="background-color: transparent; box-shadow: none;">
                                                    <td></td>
                                                    <td class="bg-table-tr-modal">
                                                        <div>
                                                            {{ x.itemName }}
                                                        </div>
                                                    </td>
                                                    <td class="bg-table-tr-modal">
                                                        {{ x.description }}
                                                    </td>
                                                    <td class="bg-table-tr-modal">
                                                        {{ numberWithCommas(x.quantity) }}
                                                    </td>
                                                    <td class="bg-table-tr-modal">
                                                        {{
                                                            formatCurrency(
                                                                x.unitCost
                                                            )
                                                        }}
                                                    </td>
                                                    <td class="bg-table-tr-modal">
                                                        {{
                                                            formatCurrency(
                                                                x.totalWithInflation
                                                            )
                                                        }}
                                                        <div v-if="x.totalInflation > 0">
                                                            <small>Inflation:
                                                                {{ formatCurrency(x.totalInflation) }}</small>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col mb-3">
                        <div class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                            ">
                            <ul class="
                                    pagination pagination-rounded
                                    mb-0
                                ">
                                <!-- pagination -->
                                <b-pagination v-model="currentPageItem" :total-rows="rowsResourceItem"
                                    :per-page="perPageItem"></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-modal>
</template>